// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"bc5c35cf","364":"7fc78049"}[chunkId] + ".chunk.js";
};